import { Component, inject, signal, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ICustomerListView } from '../shared/models';
import { CustomerService } from '../shared/customer.service';
import { CommonModule } from '@angular/common';
import { ToolbarActions } from '@shared/ui/tp-toolbar/toolbar-actions';

@Component({
  selector: 'app-customer-list',
  imports: [
    MatButtonModule,
    RouterModule,
    MatIconModule,
    ToolbarActions,
    CommonModule,
  ],
  templateUrl: './customer-list.component.html',
  styleUrl: './customer-list.component.scss',
})
export class CustomerListComponent implements OnInit {
  private service: CustomerService = inject(CustomerService);
  customers = signal<ICustomerListView[]>([]);

  ngOnInit() {
    this.service.listviewcustomers().subscribe((customers) => {
      this.customers.set(customers);
    });
  }
}
